import { getCriticalTimeoutMs } from "utils/request-timeouts";

import { emptySplitApi } from "./empty-split-api";
import {
  SendBirdUser,
  UserChangePassword,
  UserDetails,
  UserPhotoInput,
  UserResponse
} from "./types/users.type";

export const usersApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getUser: builder.query<UserResponse, number>({
      query: (id) => `/auth/users/${id}/`,
      providesTags: ["Users"]
    }),
    getMySendBirdDetails: builder.query<SendBirdUser, void>({
      // Critical bootstrap sibling — armed with the LD bootstrap timeout
      // (undefined = off = no timeout). TIMEOUT_ERROR retries via the wrapper.
      query: () => ({
        url: "/auth/users/me/sendbird/",
        timeout: getCriticalTimeoutMs()
      }),
      providesTags: ["SendbirdUsers"]
    }),
    updateUser: builder.mutation<
      UserResponse,
      Partial<UserDetails> & { id: number }
    >({
      query: ({ id, ...data }) => ({
        url: `/auth/users/${id}/`,
        method: "PATCH",
        body: data
      }),
      invalidatesTags: ["Users"]
    }),
    updateUserPhoto: builder.mutation<UserResponse, UserPhotoInput>({
      query: ({ id, formData }) => ({
        url: `/auth/users/${id}/`,
        method: "PATCH",
        body: formData
      }),
      invalidatesTags: ["Users"]
    }),
    changePassword: builder.mutation<UserResponse, UserChangePassword>({
      query: (body) => ({
        url: `/auth/change-password/`,
        method: "PATCH",
        body
      }),
      invalidatesTags: ["Users"]
    })
  })
});

export const {
  useGetUserQuery,
  useLazyGetUserQuery,
  useUpdateUserMutation,
  useUpdateUserPhotoMutation,
  useChangePasswordMutation,
  useGetMySendBirdDetailsQuery
} = usersApi;
